export const GET_LOGGED_IN_USER_FETCH_REQUESTED = 'GET_LOGGED_IN_USER_FETCH_REQUESTED'
export const GET_LOGGED_IN_USER_FETCH_SUCCESS = 'GET_LOGGED_IN_USER_FETCH_SUCCESS'
export const GET_LOGO_FETCH_REQUESTED = 'GET_LOGO_FETCH_REQUESTED'
export const GET_LOGO_FETCH_SUCCESS = 'GET_LOGO_FETCH_SUCCESS'
export const REFRESH_HEADER = 'REFRESH_HEADER'
